import { styled } from "@linaria/react";
import { spacings, colors } from "@ui/Theme";

export const Hr = styled.hr`
  margin: ${spacings.m} 0;
  height: 0px;
  border: none;
  border-top: 1px solid ${colors.titanium200};
`;
